<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";


    onMount(() => {
    });


</script>

<div class="tips-message-area-view">
    <div class="icon-area">
        <FontAwesomeView icon="circle-info"/>
    </div>
    <div class="message-area">
        <slot/>
    </div>


</div>


<style lang="scss">
    .tips-message-area-view {
        display: flex;
        margin: 1em;
        gap: 1em;
        padding: 0.5em;
        background-color: #fff9;
        font-size: 0.75em;

        border-style: solid;
        border-width: 1px;
        border-color: #0003;
        border-radius: 4px;

        .message-area {
            white-space: pre-line;
        }

    }
</style>